"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class ToolsBoardWrapper extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToolsBoardLoaded: false
    };
    this._init();
  }
  _init() {
    this.toolsBoard = null;
    this._loadToolsBoardDropin();
  }
  async _loadToolsBoardDropin() {
    if (this.state.isToolsBoardLoaded === false) {
      // eslint-disable-next-line react/prop-types
      this.toolsBoard = await this.props.getToolsBoardComponent();
      this._setToolsBoard();
    }
  }
  _setToolsBoard() {
    this.setState({
      isToolsBoardLoaded: true
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, this.state.isToolsBoardLoaded ? /*#__PURE__*/_react.default.createElement(this.toolsBoard, null) : null);
  }
}
var _default = exports.default = ToolsBoardWrapper;